<template>
  <modal
    :title="$t('titles.manageCompatibility')"
    @hidden="onHidden"
    class="product-family-compatibility-form"
    playground
    ref="modal"
  >
    <form @submit.prevent="submit">
      <div class="uk-modal-body">
        <product-family-combobox
          :disabled="!isEditable"
          :errors="fields.errors.compatibleFamily"
          :filter="{
            bundle: false,
            omittedIds: unselectableFamilyIds,
          }"
          :label="$t('fields.compatibleFamily')"
          v-if="!values"
          v-model="fields.values.compatibleFamily"
        />

        <product-family-compatibility-requirement-alternatives-manager
          :errors="fields.errors.requirementAlternatives"
          :label="$t('fields.requirements')"
          :unselectable-family-ids="unselectableRequiredFamilyIds"
          :value="fields.values.requirementAlternatives"
          @change="fields.change.requirementAlternatives"
        />
      </div>

      <div class="uk-modal-footer uk-text-right">
        <submit-button
          :disabled="!isSubmittable"
          type="primary"
        >{{$t('actions.save')}}</submit-button>

        <common-button @click="hide">{{$t('actions.cancel')}}</common-button>
      </div>
    </form>
  </modal>
</template>

<script>
import Authentication from '@/mixins/Authentication';
import CommonButton from '@/components/CommonButton';
import Form from '@/mixins/Form';
import Modal from '@/components/Modal';
import ProductFamilyCombobox from '@/components/ProductFamilyCombobox';
import ProductFamilyCompatibilityRequirementAlternativesManager
  from '@/components/ProductFamilyCompatibilityRequirementAlternativesManager';
import SubmitButton from '@/components/SubmitButton';

export default {
  name: 'product-family-compatibility-form',
  components: {
    CommonButton,
    Modal,
    ProductFamilyCombobox,
    ProductFamilyCompatibilityRequirementAlternativesManager,
    SubmitButton,
  },
  mixins: [
    Authentication,
    Form({
      compatibleFamily: { type: Form.Types.Reference, required: true },
      requirementAlternatives: {
        type: Form.Types.Array,
        load(alternatives) {
          return alternatives.map(alternative => ({
            requiredFamilies: alternative.requiredFamilies,
          }));
        },
        dump(alternatives) {
          return alternatives.map(alternative => ({
            requiredFamilyIds: alternative.requiredFamilies.map(fam => fam.id),
          }));
        },
      },
    }),
  ],
  props: {
    unselectableFamilyIds: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    unselectableRequiredFamilyIds() {
      const ids = [...this.unselectableFamilyIds];
      const { compatibleFamily } = this.fields;
      if (compatibleFamily) {
        ids.push(compatibleFamily.id);
      }
      return ids;
    },
  },
  methods: {
    show() {
      this.$refs.modal.show();
    },
    hide() {
      this.$refs.modal.hide();
    },
    onHidden() {
      this.reset();
      this.$emit('hidden');
    },
  },
  i18n: {
    messages: {
      de: {
        titles: {
          manageCompatibility: 'Produktkompatibilität verwalten',
        },
        fields: {
          compatibleFamily: 'Kompatible Produktfamilie',
          requirements: 'Erforderliche Produktfamilien',
        },
      },
    },
  },
};
</script>



// WEBPACK FOOTER //
// ProductFamilyCompatibilityForm.vue?1a9caa64